import { Box, Container, Heading, SimpleGrid, Text } from '@chakra-ui/react';
import PageHeader from 'components/page-header/PageHeader';
import PageTitleMobile from 'components/page-header/PageTitleMobile';
import { withIronSessionSsr } from 'iron-session/next';
import RootLayout from 'layouts/RootLayout';
import { sessionOptions } from 'libs/iron-session';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Head from 'next/head';
import { NextPageWithLayout } from './_app';
import Image from 'next/image';

const WarrantyPolicyPage: NextPageWithLayout = () => {
  return (
    <>
      <Head>
        <title>นโยบายรับประกันสินค้า | แลมป์ตั้น</title>
      </Head>
      <Box>
        <PageHeader title={`นโยบายรับประกันสินค้า`}></PageHeader>
        <PageTitleMobile>{`นโยบายรับประกันสินค้า`}</PageTitleMobile>
        <Container
          pt={{
            base: 8,
            md: 12,
          }}
          pb={{
            base: 8,
            md: 20,
          }}
        >
          <Heading fontWeight="500" mb={6} fontSize="lg">
            นโยบายการรับประกันสินค้าสำหรับการสั่งซื้อผ่าน LAMPTAN SHOP ONLINE
          </Heading>
          <Heading fontWeight="500" mb={6} fontSize="lg">
            เงื่อนไขการรับประกัน
          </Heading>
          <Box
            mb={{
              base: 8,
              md: 10,
            }}
          >
            <ul
              style={{
                marginLeft: '20px',
              }}
            >
              <li
                style={{
                  marginBottom: '4px',
                }}
              >
                บริษัทฯ ขอรับประกันคุณภาพผลิตภัณฑ์ที่ลูกค้าได้ซื้อสินค้า รุ่น
                และรหัสที่ระบุอยู่ในตัวสินค้า และใบรับประกัน เท่านั้น
              </li>
              <li
                style={{
                  marginBottom: '4px',
                }}
              >
                ระยะประกันเริ่มนับตั้งแต่วันที่สินค้าได้มีการซื้อขายและส่งมอบกันระหว่างลูกค้ากับบริษัทฯ
                โดยมีระยะเวลาประกัน 1 ปี
              </li>
              <li
                style={{
                  marginBottom: '4px',
                }}
              >
                ผู้ซื้อสามารถขอรับบริการตรวจสอบ ซ่อม และเปลี่ยนอะไหล่
                (กรณีที่บริษัทฯ พบว่าสินค้าอยู่ในกรณีรับผิดชอบ
                โดยผู้ซื้อไม่ต้องเสียค่าใช้จ่ายในส่วนค่าแรง และชิ้นส่วนอะไหล่)
              </li>
              <li
                style={{
                  marginBottom: '4px',
                }}
              >
                การรับประกันอยู่ในกรณีที่ สินค้า ไม่สามารถใช้งานได้ เช่น
                ไฟไม่ติด, หลอดกระพริบ เป็นต้น
              </li>
              <li
                style={{
                  marginBottom: '4px',
                }}
              >
                การรับประกันนี้ไม่รวมถึง ค่าพาหนะ
                ค่าขนส่งในการให้บริการนอกสถานที่และนอกเขตบริการของบริษัทฯ
              </li>
              <li
                style={{
                  marginBottom: '4px',
                }}
              >
                กรณีสินค้าบกพร่องที่เกิดจากการผลิต ทางบริษัทฯ
                จะเปลี่ยนสินค้าให้ใหม่หรือทดแทนด้วยสินค้ารุ่นเทียบเท่า
              </li>
              <li
                style={{
                  marginBottom: '4px',
                }}
              >
                ในกรณีที่เกิดความเสียหายขึ้นแต่ทางบริษัทไม่สามารถจัดหาวัสดุหรือชิ้นส่วนในรายการเดียวกันเพื่อใช้ในการซ่อมแซม
                หรือเปลี่ยนให้ได้ในระยะเวลาการซ่อมแซม บริษัทฯ
                ขอสงวนสิทธิ์ในการจัดหาวัสดุที่มีคุณสมบัติและมาตรฐานเท่าเทียมกันมาทดแทน
              </li>
              <li
                style={{
                  marginBottom: '4px',
                }}
              >
                ในกรณีที่สินค้าของท่านได้รับการเปลี่ยนชิ้นส่วน
                หรือได้รับการซ่อมแซมแล้ว
                ระยะเวลาการรับประกันสินค้าจะยังคงมีผลนับจากวันที่ท่านได้รับสินค้า
                โดยไม่ได้ขยายเวลานับจากวันที่มีการซ่อมแซมสินค้า
              </li>
              <li
                style={{
                  marginBottom: '4px',
                }}
              >
                ลูกค้าต้องมอบชิ้นส่วนที่ชำรุดบกพร่องของผลิตภัณฑ์ตามรายการที่ได้รับประกันคืนให้แก่เจ้าหน้าที่ของบริษัทฯ
              </li>
              <li
                style={{
                  marginBottom: '4px',
                }}
              >
                บริษัทฯ ขอสงวนสิทธิ์ในการเป็นผู้วินิจฉัย
                และตัดสินใจว่าสินค้านั้น ๆ อยู่ในเงื่อนไขการรับประกันหรือไม่
                คำตัดสินของบริษัทฯ ถือเป็นที่สิ้นสุด
              </li>
            </ul>
          </Box>
          <Heading fontWeight="500" mb={6} fontSize="lg">
            เงื่อนไขที่ไม่ได้อยู่ในการรับประกัน
          </Heading>
          <ul
            style={{
              marginLeft: '20px',
            }}
          >
            <li
              style={{
                marginBottom: '4px',
              }}
            >
              สินค้าชำรุดเพราะถูกใช้ในทางที่ผิดจุดประสงค์ที่ออกแบบไว้ ใช้ผิดวิธี
              และขาดการบำรุงรักษาที่ถูกต้อง
            </li>
            <li
              style={{
                marginBottom: '4px',
              }}
            >
              สินค้าถูกดัดแปลง ต่อเติม แก้ไข ซ่อมแซมโดยที่มิใช่ช่างของบริษัทฯ
            </li>
            <li
              style={{
                marginBottom: '4px',
              }}
            >
              สินค้าชำรุด มีตำหนิ บุบสลาย หรือเกิดรอยขีดข่วน
              อันเนื่องมาจากสาเหตุภายนอก เช่น การขนส่ง การเคลื่อนย้าย อุบัติเหตุ
              ความประมาทเลินเล่อ ผลิตภัณฑ์ถูกสารเคมี ภัยธรรมชาติ สัตว์ต่าง ๆ
            </li>
            <li
              style={{
                marginBottom: '4px',
              }}
            >
              สินค้าสูญหายจากการขนส่ง
            </li>
            <li
              style={{
                marginBottom: '4px',
              }}
            >
              สินค้าที่ได้รับไม่ตรงตามรายละเอียดสินค้าที่ระบุในเว็บไซต์
            </li>
            <li
              style={{
                marginBottom: '4px',
              }}
            >
              สินค้าที่ได้รับไม่ตรงตามรายการสั่งซื้อ
            </li>
            <li
              style={{
                marginBottom: '4px',
              }}
            >
              สินค้าที่ได้รับความเสียหายอันเกิดจากระบบ
              หรือแรงดันไฟฟ้าไม่ถูกต้องกับผลิตภัณฑ์ที่แนะนำและออกแบบไว้
            </li>
            <li
              style={{
                marginBottom: '4px',
              }}
            >
              บริษัทฯ ไม่รับประกันสินค้าที่ใช้แล้ว
              ซึ่งลูกค้าทำการซื้อต่อจากบุคคลอื่น โดยมิได้ซื้อจากบริษัทฯ
            </li>
            <li
              style={{
                marginBottom: '4px',
              }}
            >
              ใบรับประกันที่ถูกแก้ไข ขูด ขีดฆ่า สูญหาย จะถือว่าเป็นโมฆะ
            </li>
            <li
              style={{
                marginBottom: '4px',
              }}
            >
              สินค้ากลุ่ม Clearance
            </li>
          </ul>
        </Container>
      </Box>
    </>
  );
};

WarrantyPolicyPage.getLayout = (page) => {
  return <RootLayout>{page}</RootLayout>;
};

export const getServerSideProps = withIronSessionSsr(async function ({
  req,
  res,
  locale,
}) {
  const _locale = locale || 'th';

  return {
    props: {
      ...(await serverSideTranslations(_locale, ['common'])),
    },
  };
},
sessionOptions);

export default WarrantyPolicyPage;
